import React from 'react'

const AboutMain = () => {
  return (
    <div id='website-responsive' className=''>
    <div className='bg-img' style={{ backgroundImage:'url("about-us/About-Us-Banner-v1.webp")', height:'100%', width:'100%'}}>
        <div className='toxicology-text-padding'>
            <div className='-max-width display-none-1150'>
                <text className='fs-ss-42 text-montserrat fw-700 lh-1-2 text-ss-primary' style={{ letterSpacing:'-1px'}}>
                BEST LABORATORY<br/>
                TESTING CENTER IN<br/>
                CHICAGOLAND AREA
                </text>
            </div>

            <div className='services2-max-width display-block-1150'>
                <text className='fs-ss-32-4 text-montserrat fw-600 lh-1 text-ss-primary ' style={{ letterSpacing:'-1px'}}>
                Best laboratory
                testing center
                in Chicagoland area
                </text>
            </div>
        </div>
    </div>
</div>
  )
}

export default AboutMain